/* eslint-disable max-len */
import { ChangeDetectorRef, Component, HostListener, OnInit, TemplateRef } from '@angular/core';
import {  NavigationExtras, Router } from '@angular/router';
import { ItineraryService } from '../shared/itinerary.service';
import { UserService } from '../pages/com.usblick.common/auth/user.service';
import { RestService } from '../shared/rest.service';
import { FidelityService } from '../fidelity/fidelity.service';
import * as moment from 'moment';
import { AgentsService } from '../agents/agents.service';
import { Observable } from 'rxjs/Observable';
import {  ModalPostBookingComponent } from 'app/shared/modal-post-booking/modal-post-booking.component';
import { MatDialog } from '@angular/material/dialog';
import { setting } from '../../../setting';
import { Location } from '@angular/common';
import { Subscription } from 'rxjs';
import { selectPermissions } from 'app/core/profiles/profiles.selectors';
import { Store } from '@ngrx/store';
import { AppState } from 'app/core/profiles/storeProfile';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { NotificationService } from 'app/shared/notifications/notification.service';

enum ECategoryName {
  Hotels = 'HOTELS',
  Transports = 'TRANSPORTS',
  Tours = 'TOURS',
  Disney = 'DISNEY',
  Rentacar = 'RENT-A-CAR',
  Ptheme = 'PTHEMES',
  Insurance = 'INSURANCE'
}
@Component({
  selector: 'usb-details-summary-itinerary',
  templateUrl: './details-summary-itinerary.component.html',
  styleUrls: ['./details-summary-itinerary.component.scss']
})
export class DetailsSummaryItineraryComponent implements OnInit {
  allItinerary: any;
  itineraryItems: any = [];
  itinerary: any = [];
  itineraryClient: any = [];
  price: number = 0.00;
  itinerarySavedItems: any = [];
  itineraryPartialItems: any = [];
  hotelCount: number = 0;
  transportsCount: number = 0;
  toursCount: number = 0;
  disneyCount: number = 0;
  rentacarCount: number = 0;
  pthemeCount: number = 0;
  insuranceCount: number = 0;
  productsReserved: String = "";
  priceTotal: number = 0;
  paxesNumber: any;
  from: string = 'partial-reserve';
  titleStatus: string = '';
  partialReserve: boolean = false;
  itineraryID: any;
  modalRef: BsModalRef;
  element: HTMLElement;
  element_: HTMLElement;
  loaded = false;
  itineraryId: number;
  totalPointAdded: number = 0; // total puntos sumados en la reserva
  pointsAvailable: number = 0; // total puntos acumulados
  pointCategory: any = 0;
  nameClient: any;
  totNight: number = 0;
  cantAdults:number = 0;
  cantChilds:number = 0;
  totalTarifaNeta: number = 0;
  totalTarifa: number = 0;
  totalPointGlobal:number = 0;
  itineraryItemsArr: [] = [];
  public id: number;
  totalNetPriceBookingFreeTax: number;
  totalTaxPrice: number;
  public bookingURL: string;
  buttonPay: boolean = true;

  public routeUploadFile:any;
  public logoAgency: any;
  public imageLogo: any;
  public dateFromCancellation: any;
  public totalAdults: number;
  public totalChildren: number;

  itinerary$: Observable<any[]>;
  isGeneratingPDF = false;

  public getClientsSettingAppBooking: any;
  public imageAgencyVoucher: any;
  public categoryImage: any;
  public bedVoucher = '../../assets/img/app/base64/voucher-reservation/bed';
  public colorNumberVoucher: any;
  private itinerarySubscription: Subscription;
  totalNights: number;

  public moduleProfile: any[] = [];

  public appLoading: boolean = true;
  public currencyItinerary: string;
  qtyNights:number = 0;
  qtyDays:number = 0;
  qtyAdults:number = 0;
  qtyChilds:number = 0;


  clientData: any = {
    name: null,
    mail: null,
    phone: null
  };

  flightInfo: any = {
    thisdepartureDate: null,
    arrivalDate: null,
    airport: null,
    airline: null,
    flightNumber: null
  };

  paxList: any;
  destinations: any;

  agency: any;
  voucherInfo: any;
  currencies: any[] = [];
  currencyAgency: any;

  permissions$: Observable<string[]>;
  permissionsMap: { [key: string]: boolean } = {};

  @HostListener('window:popstate', ['$event'])
  onPopState(event: any): void {
    if(event) {
      this.router.navigate(['/management']);
    }
  }

  constructor(
                private router: Router,
                private modalService: BsModalService,
                private itineraryService: ItineraryService,
                public userService: UserService,
                public _restService: RestService,
                public fidelityService: FidelityService,
                public agentsService: AgentsService,
                public dialog: MatDialog,
                private store: Store<AppState>,
                private notificationService: NotificationService
              ) {

                this.routeUploadFile =  setting.routeUploadFile;
                this.bookingURL = setting.apiBookingUrl;
                }

  ngOnInit() {

    this.currencies = this.userService.currenciesExchange;
    this.getClientsSettingAppBooking = JSON.parse(localStorage.getItem(setting.name));
    const selectedAgency = JSON.parse(localStorage.getItem('selectedAgency'));
    this.currencyAgency = this.currencies.find(c => c.code === selectedAgency.currency);

    if(!this.currencyAgency) {
      this.router.navigateByUrl('home');
      this.notificationService.warning('Moneda no configurada en la agencia');
    }

    this.permissions$ = this.store.select(selectPermissions);
    // Despacha las acciones para cargar roles y permisos
    // this.store.dispatch({ type: '[Auth] Load Permissions' });

    this.permissions$.subscribe(permissions => {
      this.permissionsMap = this.createPermissionsMap(permissions);
    });
      // this.location.replaceState('/details-summary-itinerary');
  this.itineraryService.consultActiveItinerary(this.userService._agentID, false, null, 'detail-summary-itinerary');
      this.getItineraryInfo();


    this.logoAgency =  this.getClientsSettingAppBooking?.logo_path_one;
    this.imageAgencyVoucher = this.getClientsSettingAppBooking?.clients_setting_global?.logo64;
    this.colorNumberVoucher = this.getClientsSettingAppBooking?.clients_setting_global?.color_main_3;

    this.agency = JSON.parse(localStorage.getItem('selectedAgency'));
  }

  createPermissionsMap(permissions: any[]): { [key: string]: any } {
    const map: { [key: string]: any } = {};
    permissions.forEach((permission) => {
      // Utiliza el nombre del permiso como clave
      map[permission.name] = permission;
    });
    return map;
  }

  vouchersReservationPdf(id: number): void {

    this.itineraryService.voucherDownload(id, this.getClientsSettingAppBooking.id, 'only', 1);



  }


  liduidationItinerayPdf() {

     this.itineraryService.liquidationDownload(this.id, this.getClientsSettingAppBooking.id);

  }

  goManagament(): void {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        'id': this.itineraryID,
        'stat': 'true',
        'screen': 'detail'
      }
    };

    this.router.navigate(['mannagement/itineraries'], navigationExtras);

  }

  setDateHead(date: string) {
    if (date) {
      let dateSplit = date.split("-");
      return '' + dateSplit[2] + '-' + moment().month(parseInt(dateSplit[1]) - 1).format('MMM-Y');
    }
  }


getTotalNights(): number {
    if (!this.itineraryItems.items || !Array.isArray(this.itineraryItems.items)) {
        return 0;
    }

// FILTRAR solo items con category_id === 1
    const filteredItems = this.itineraryItems.items.filter(item => item.category_id === 1);

    // Si no hay items con category_id === 1, retornar 0
    if (filteredItems.length === 0) {
        return 0;
    }

    const dateRanges = filteredItems.map(item => ({
        start: moment(item.arrivalDate),
        end: moment(item.departureDate)
    }));

    // Ordenar por fecha de inicio
    dateRanges.sort((a, b) => a.start.diff(b.start));

    // Consolidar intervalos
    const consolidated = [];
    let current = dateRanges[0];

    for (let i = 1; i < dateRanges.length; i++) {
        const next = dateRanges[i];

        if (next.start.isSameOrBefore(current.end)) {
            if (next.end.isAfter(current.end)) {
                current.end = next.end;
            }
        } else {
            consolidated.push(current);
            current = next;
        }
    }
    consolidated.push(current);

    // Sumar noches
    return consolidated.reduce((total, range) => {
        return total + range.end.diff(range.start, 'days');
    }, 0);
}

  getAdults(){
    let cantAdults = 0;
      cantAdults += this.itineraryItems.totalAdultsMax;
      return cantAdults;
  }

  getCantChilds(){
    let cantChilds = 0;
      cantChilds += this.itineraryItems.totalChildrenMax;
    return cantChilds;
  }


  totalPrice(charge: any) {
    // eslint-disable-next-line max-len
    /*if  (this.itineraryItems.totalFee != null) {
      return Number.parseFloat(this.itineraryItems.totalPrice) + Number.parseFloat(this.itineraryItems.totalFee);
    } else {
      return Number.parseFloat(this.itineraryItems.totalPrice);
    } */


  }

  getItineraryInfo() {
    this.loaded = false;
    this.itinerary$ = this.itineraryService.getItinerary$();
    this.itinerarySubscription = this.itinerary$.subscribe((data:any) => {
    this.validateQtyChildsAndAdults(data);
    if (data && Object.keys(data).length > 0) {


      if (data !== undefined) {
        this.itineraryItems = data[0];
        this.itineraryID = data[0].id;
        this.itineraryClient = data[1];
        this.nameClient = data[1]?.first_name + ' ' + data[1]?.last_name;

        this.cantAdults = this.getAdults();
        this.cantChilds = this.getCantChilds();
        this.currencyItinerary = this.itineraryItems.currency;
        let paxes = (this.itineraryItems.totalAdults + this.itineraryItems.totalChildren) - 1;
        this.paxesNumber = paxes > 0 ? 'x ' + paxes : '';
        this.getPartialAndSavedItems();
        this.dateFromCancellation = this.getDateCancellationMinor();
        this.itineraryItemsArr = this.itineraryItems?.items;
        this.id = this.itineraryItems.id;
        this.pointCategory = this.fidelityService.getCalculatePointsByCategory(this.itineraryItems.items);

        this.pointsAvailable = this.itineraryItems.totalBlickoins;
        if(this.pointsAvailable) {
          this.totalPointGlobal = 1;
        }
        if (this.itineraryItems && this.itineraryItems.items && Array.isArray(this.itineraryItems.items)) {
          // Calcula la suma de paxAdults y paxChildren
          this.totalAdults = this.itineraryItems.items.reduce((sum, item) => sum + (item.paxAdults || 0), 0);
          this.totalChildren = this.itineraryItems.items.reduce((sum, item) => sum + (item.paxChildren || 0), 0);
          this.totalNetPriceBookingFreeTax = this.itineraryItems.items.reduce((sum, item) => sum + (item.totalNetPriceBookingFreeTax || 0), 0);
          if(this.itineraryItems.items && this.itineraryItems.items.length > 0 && this.itineraryItems.items[0].taxes && this.itineraryItems.items[0].taxes.length > 0) {
            this.totalTaxPrice = this.itineraryItems.items[0].taxes?.reduce((sum, item) => sum + (/* Descomentar en el caso que se requiera el precio de totaltaxprice - item.totalTaxPrice */ item.amount || 0), 0);
          }
        }



      } else {
        this.itineraryItems = this.userService.itineraryActive[0];
        this.itineraryID = this.userService.itineraryActive[0].id;
        this.itineraryClient = this.userService.itineraryActive[1];
        let paxes = (this.itineraryItems.totalAdults + this.itineraryItems.totalChildren) - 1;
        this.paxesNumber = paxes > 0 ? 'x ' + paxes : '';
        this.getPartialAndSavedItems();
      }



      this.userService.totalNetReserved = localStorage.getItem('totalNetReserved');
      this.userService.totalReserved = localStorage.getItem('totalReserved');
      // this.totalTarifaNeta = this.itineraryItems.totalPriceByNetReserved;
      //this.totalTarifa  = this.itineraryItems.totalPriceByReserved;


      this.totalNights = this.getTotalNights();
      this.loaded = true;
    }

      this.appLoading = false;
    });
  }

getDateCancellationMinor(): string {
  let dateMinor: string = '';

  this.itineraryItems.items.forEach((item: any) => {
    if (item.category_id === 1) {
      // ✅ Validar que cancellationPolicy existe y tiene al menos un elemento
      const cancellationPolicy = item?.room?.cancellationPolicy;
      if (cancellationPolicy && cancellationPolicy.length > 0 && cancellationPolicy[0]?.from) {
        dateMinor = cancellationPolicy[0].from;
      }
    }
  });

  return dateMinor;
}

  formatDateExpiration (date: any) {

    return date.moment().format('DD/MM/YYYY');

  }
  getLocation(item): string {
    let location;
    switch (item.categoryName) {
      case "DISNEY":
        location = item.hotel.additionalInfo.location;
        break;
      case "INSURANCE":
        location = item.destination.iata_code;
        break;
      case "TOURS":
        location = `${item?.form?.destination?.city_name}, ${item.form?.destination?.country_name}`;
        break;
      case "RENT-A-CAR":
        location = item?.form?.origin?.name || item?.form?.origin?.city_name;
        break;
      case "TRANSPORTS":
        location = item.destination[0].destination_info.cityName;
        break;
      default:
        location = item.location;
        break;
    }
    return location;
  }


  stingUpperCase(str: any) {
    if (str) {
      let e = str.toLowerCase();
      return e.replace(/\b\w/g, (l) => l.toUpperCase());
    }
  }


  subtractDays(date){
    return moment(moment(date)).subtract(2, 'days').format('YYYY-MM-DD');
  }

  getPartialAndSavedItems() {
    this.itineraryItems.items.forEach(element => {
      if (element.partial_selected == 1) {
        this.itineraryPartialItems.push(element);
      } else {
        this.itinerarySavedItems.push(element);
      }
      this.setCountOfProduct(element);
    });

    this.setProductsReserved();
    //this.price = this.partialReserve!==true ? this.itineraryItems.totalPrice : this.itineraryItems.totalPricePartial;
    this.price = this.itineraryItems.netPriceBooking;

  }

  setCountOfProduct(item: any) {
    let priceElement: number = 0;
    switch (item.categoryName) {
      case ECategoryName.Hotels:
        this.hotelCount = this.hotelCount + item.nights;
        priceElement = item.netPrice;
        break;
      case ECategoryName.Disney:
        this.disneyCount = this.disneyCount + 1;
        priceElement = item.totalPrice;
        break;
      case ECategoryName.Insurance:
        this.insuranceCount = this.insuranceCount + 1;
        priceElement = item.totalPrice;
        break;
      case ECategoryName.Ptheme:
        this.pthemeCount = this.pthemeCount + 1;
        priceElement = parseFloat(item.optionTotal);
        break;
      case ECategoryName.Rentacar:
        this.rentacarCount = this.rentacarCount + 1;
        priceElement = item.totalPrice;
        break;
      case ECategoryName.Tours:
        this.toursCount = this.toursCount + 1;
        priceElement = item.totalPrice;
        break;
      case ECategoryName.Transports:
        this.transportsCount = this.transportsCount + 1;
        priceElement = item.totalPrice;
        break;
    }
    this.priceTotal += priceElement;
  }

  setProductsReserved() {
    if (this.hotelCount > 0) {
      this.productsReserved = this.productsReserved + '' + this.hotelCount + ' Night in Hotels, ';
    }
    if (this.disneyCount > 0) {
      this.productsReserved = this.productsReserved + '' + this.disneyCount + ' Disney, ';
    }
    if (this.insuranceCount > 0) {
      this.productsReserved = this.productsReserved + '' + this.insuranceCount + ' Insurance, ';
    }
    if (this.pthemeCount > 0) {
      this.productsReserved = this.productsReserved + '' + this.pthemeCount + ' Tickets PTheme, ';
    }
    if (this.rentacarCount > 0) {
      this.productsReserved = this.productsReserved + '' + this.rentacarCount + ' Rent a Car, ';
    }
    if (this.toursCount > 0) {
      this.productsReserved = this.productsReserved + '' + this.toursCount + ' Tickets Tours, ';
    }
    if (this.transportsCount > 0) {
      this.productsReserved = this.productsReserved + '' + this.transportsCount + ' Transports, ';
    }

    this.productsReserved = this.productsReserved.toString().substring(0, this.productsReserved.length - 2);
  }


  goToReserve() {
    let navigationExtras: NavigationExtras = {
      queryParams: {
        "from": this.partialReserve === true ? 'partial-reserve' : 'total-reserve',
        "step": "two",
        "itineraryId": this.itineraryID
      }
    };
    this.router.navigate(["itinerary-reservation"], navigationExtras);
  }

  sendMail() {
    this.element_ = document.getElementById('items-' + this.itineraryID) as HTMLElement;
    if (this.element_) {
      this.element = document.getElementById('contentPDF-' + this.itineraryID) as HTMLElement;
      this.itineraryService.postSendEmail(this.itineraryItems, this.element.innerHTML).subscribe(
        (response: any) => {
          if (response['send'] === 'true') {
            this.modalRef.hide();
          } else {
            this.modalRef.hide();
          }
        },
      );
    }
  }

  goToDownloadPdf() {
    this.element_ = document.getElementById('items-' + this.itineraryID) as HTMLElement;
    if (this.element_) {
      // return xepOnline.Formatter.Format('contentPDF-' + this.itineraryID,
      // {render: 'download', filename: [this.itineraryID + '-' + this.itineraryItems.title]
      // });
    }
  }

  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template, { class: 'modal-sm' });
  }

  closeModal(): void {
    this.modalRef.hide();
  }

  goToItinerary() {
    const navigationExtras: NavigationExtras = {
      queryParams: {
        'id': this.itineraryID,
        'stat': 'true',
        'screen': 'detail'
      }
    };

    this.router.navigate(['mannagement/itineraries'], navigationExtras);
  }

  formatPrice(value) {
    let val = (value / 1).toFixed(2).replace('.', ',')
    return val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ".")
  }


  pay(){
    this.buttonPay = false;
    var dialogRef = this.dialog.open(ModalPostBookingComponent, {
      width: '899px',
      height: '80vh',
      data: {itinerary: this.itineraryItems,  type: 'payment'},
      //disableClose: true
    });

    dialogRef.componentInstance.savePayments();

    dialogRef.afterClosed().subscribe(result => {
      //console.log('The dialog was closed', result);
      if(result){
        const itinerary$ = this.itineraryService.getItinerary$();
        this.itinerary$.subscribe((data:any) => {
          data[0].items.forEach((item: any) => {
            if(item.status_id === 1) {
              this.buttonPay = true;
            }
          })
        });
        // this.goToItinerary();
        // this.getItinerary();
      }else{
        this.buttonPay = true;
      }
    });

  }

  searchProductReserved()
  {
    if(this.itineraryItems && this.itineraryItems.items && this.itineraryItems.items.length > 0) {
      let result = this.itineraryItems.items.filter(element => element.status_id === 2 || element.status_id === 3);
      if(result.length > 0){
        let i =0;
        result.forEach(element => {
          if (element.isPendigApprovePay===false && element.isPaidAgency===false && element.isPaidProvider===false && element.isBilled===false){
            i++;
          }
        });

        if(i > 0){
          return true;
        } else {
          return false;
        }
      }
    }
  }

  downloadLiquidation(id: number): void {
    const url = `${this.bookingURL}downloadLiquidations/${id}/${this.getClientsSettingAppBooking.id}`;
    window.open(url);
  }

    extractNameTransport(form: any, type: string): string {
    switch(type) {
      case 'origin':
        switch(form.payload[0].transfers.pickupLocation.type) {
          case 'hotel':
            return `${form.formTransport?.firstOrigin?.name || form.formTransport?.firstOrigin?.hotel_name}`;
          case 'airport':
            return `${form.formTransport?.firstOrigin?.name} (${form.formTransport?.firstOrigin?.iata})`;
          case 'destination':
            return `${form.formTransport?.firstOrigin?.city_name}`;
        }
      case 'destination':
        switch(form.payload[0].transfers.dropoffLocation.type) {
          case 'hotel':
            return `${form.formTransport?.firstDestination?.name || form.formTransport?.firstOrigin?.hotel_name }`;
          case 'airport':
            return `${form.formTransport?.firstDestination?.name} (${form.formTransport?.firstDestination?.iata})`;
          case 'destination':
            return `${form.formTransport?.firstDestination?.city_name}`;
        }
    }
  }

  getMessageFirstTime(pickupOrDropoff: any,input: string): string {

  let firstOrigin = {};
  let firstDestination = {};

  firstOrigin = input === 'origin' ? pickupOrDropoff : {};
  firstDestination = input === 'destination' ? pickupOrDropoff : {};

  let message: string = '';
  let messageFly: string = '';
  // const messageFly = 'Hora arribo del vuelo';
  if(input === 'origin') {
    messageFly = pickupOrDropoff?.originDateTransfers === 'fly' ? 'Arribo del vuelo' : 'Hora del pickup';
  } else {
    messageFly = pickupOrDropoff?.originDateTransfers === 'fly' ? 'Arribo del vuelo' : 'Hora del pickup';
  }
  const messageDestination = 'Hora pickup del hotel';

  if(firstOrigin && firstOrigin['type']) {
    message = firstOrigin['type'] === 'airport' ? messageFly : messageDestination;
  }

  if(message === '') {
    message = firstDestination && firstDestination['type'] === 'airport' ? messageFly : messageDestination;
  }

  return message

  }


    extractAddressType(form: any, type: string): string {
    switch(type) {
      case 'origin':
        switch(form.payload[0].transfers.pickupLocation.type) {
          case 'hotel':
            return `${form.payload[0].transfers.pickupLocation.address} (${form.payload[0].transfers.pickupLocation.origin})`;
          case 'airport':
            return `${form.formTransport?.firstOrigin?.name} (${form.formTransport?.firstOrigin?.iata})`;
          case 'destination':
            return `${form.formTransport?.firstOrigin?.city_name} (${form.formTransport?.firstOrigin?.country_code})`;
        }
      case 'destination':
        switch(form.payload[0].transfers.dropoffLocation.type) {
          case 'hotel':
            return `${form.payload[0].transfers.dropoffLocation.address} (${form.payload[0].transfers.dropoffLocation.destination})`;
          case 'airport':
            return `${form.formTransport?.firstDestination?.name} (${form.formTransport?.firstDestination?.iata})`;
          case 'destination':
            return `${form.formTransport?.firstDestination?.city_name} (${form.formTransport?.firstDestination?.country_code})`;
        }
    }


  }

    copyToClipboard(value: string | undefined): void {
  if (!value) return;
  navigator.clipboard.writeText(value)
    .then(() => {
      this.notificationService.info(`Localizador copiado: ${value}`);
      // Podés agregar una notificación aquí si querés
    })
    .catch(err => {
      console.error('Error al copiar al portapapeles:', err);
    });
}

          getNetTarifa() {
            let price = 0;
            // price = this.itinerary.totalNetPriceBooking ? this.itinerary.totalNetPriceBooking  : 0;
            price = this.calculateTotal('netPriceBookingFreeTax');
            return price;
          }


          getTotalTarifa() {
            let price = 0;
            //  price = this.itinerary.totalNetPriceAgent ? this.itinerary.totalNetPriceAgent  : 0;
            price = this.calculateTotal('netPriceAgent');
            return price;
          }

          getComission() {
            let comission = 0;
            comission =  this.calculateTotal('fee');
            // comission = this.itinerary.totalFee ? this.itinerary.totalFee  : 0;
            return comission
          }

          getTotalFreeTax() {
            return this.calculateTotalWithStatus('netPriceBookingFreeTax', 2);
          }

getTotalTarifaReserve(): number {
    // Usamos calculateTotalWithStatus para sumar netPriceAgent con status_id = 2
    return this.calculateTotalWithStatus('netPriceAgent', 2);
}

private calculateTotalWithStatus(fieldName: string, targetStatus: number): number {
    try {
        if (!this.itineraryItems?.items) return 0;

        const usdCurrency = this.currencies?.find(c => c.code === 'USD');
        const agencyRate = this.currencyAgency?.rate;

        if (!usdCurrency || !agencyRate) {
            console.error('Configuración de moneda faltante');
            return 0;
        }

        let totalConverted = 0; // Para items que necesitan conversión
        let totalFixed = 0;     // Para valores históricos ya convertidos

        this.itineraryItems.items.forEach((item: any) => {
            // 1. Solo procesar items con el status_id especificado
            if (item.status_id !== targetStatus) return;

            // 2. Determinar si es un item pagado/aprobado
            const isPaidOrApproved = item.isPaidAgency || item.isPaidProvider || item.isPendigApprovePay;

            if (isPaidOrApproved) {
                // 3. Obtener valor histórico (ya convertido)
                const historicValue = item?.converted_amounts?.[fieldName] || item[fieldName] || 0;
                totalFixed += parseFloat(Number(historicValue).toFixed(2));
            } else {
                // 4. Procesar items no pagados (necesitan conversión)
                if (!item[fieldName] || !item.currency) return;

                const itemCurrency = this.currencies.find(c => c.code === item.currency);
                if (!itemCurrency?.rate) return;

                const itemRate = parseFloat(itemCurrency.rate);
                const itemAmount = parseFloat(item[fieldName]);

                if (!isNaN(itemRate) && !isNaN(itemAmount) && itemRate > 0) {
                    totalConverted += itemAmount / itemRate;
                }
            }
        });

        // 5. Convertir solo la parte no pagada
        const convertedAmount = totalConverted * parseFloat(agencyRate);

        // 6. Sumar ambos totales (valores históricos + valores convertidos)
        const finalAmount = totalFixed + parseFloat(convertedAmount.toFixed(2));
        return parseFloat(finalAmount.toFixed(2));

    } catch (error) {
        console.error(`Error en calculateTotalWithStatus (${fieldName}, status ${targetStatus}):`, error);
        return 0;
    }
}


private calculateTotal(fieldName: string): number {

    return this.itineraryService.calculateTotal(
                                                fieldName,
                                                this.itineraryItems,
                                                this.currencies,
                                                this.currencyAgency);

  // try {
  //   if (!this.itineraryItems?.items) return 0;

  //   const usdCurrency = this.currencies?.find(c => c.code === 'USD');
  //   const agencyRate = this.currencyAgency?.rate;

  //   if (!usdCurrency || !agencyRate) {
  //     console.error('Configuración de moneda faltante');
  //     return 0;
  //   }

  //   let totalConverted = 0; // Para items que necesitan conversión
  //   let totalFixed = 0;     // Para valores históricos ya convertidos

  //   this.itineraryItems.items.forEach((item: any) => {
  //     // 1. Saltar items cancelados
  //     if (item.status_id === 5) return;

  //     // 2. Determinar si es un item pagado/aprobado
  //     const isPaidOrApproved = item.isPaidAgency || item.isPaidProvider || item.isPendigApprovePay;

  //     if (isPaidOrApproved) {
  //       // 3. Obtener valor histórico (ya convertido)
  //       const historicValue = item?.converted_amounts?.[fieldName] || item[fieldName] || 0;
  //       totalFixed += parseFloat(Number(historicValue).toFixed(2));
  //     } else {
  //       // 4. Procesar items no pagados (necesitan conversión)
  //       if (!item[fieldName] || !item.currency) return;

  //       const itemCurrency = this.currencies.find(c => c.code === item.currency);
  //       if (!itemCurrency?.rate) return;

  //       const itemRate = parseFloat(itemCurrency.rate);
  //       const itemAmount = parseFloat(item[fieldName]);

  //       if (!isNaN(itemRate) && !isNaN(itemAmount) && itemRate > 0) {
  //         totalConverted += itemAmount / itemRate;
  //       }
  //     }
  //   });

  //   // 5. Convertir solo la parte no pagada
  //   const convertedAmount = totalConverted * parseFloat(agencyRate);

  //   // 6. Sumar ambos totales (valores históricos + valores convertidos)
  //   const finalAmount = totalFixed + parseFloat(convertedAmount.toFixed(2));
  //   return parseFloat(finalAmount.toFixed(2));

  // } catch (error) {
  //   console.error(`Error en calculateTotal (${fieldName}):`, error);
  //   return 0;
  // }
}

getTotalTaxesForStatus2(): number {
    try {
        if (!this.itineraryItems?.items) return 0;

        const usdCurrency = this.currencies?.find(c => c.code === 'USD');
        const agencyRate = this.currencyAgency?.rate;

        if (!usdCurrency || !agencyRate) {
            console.error('Configuración de moneda faltante');
            return 0;
        }

        let totalConverted = 0; // Para taxes que necesitan conversión
        let totalFixed = 0;     // Para valores históricos ya convertidos

        this.itineraryItems.items.forEach((item: any) => {
            // 1. Filtrar SOLO items con status_id = 2
            if (item.status_id !== 2) return;

            // 2. Verificar si el item tiene taxes (para hoteles sería room.pricing.taxes)
            const taxes = item.room?.pricing?.taxes || item.taxes || [];

            if(taxes && taxes.length > 0) {

              taxes.forEach((tax: any) => {
                  // 3. Determinar si es un item pagado/aprobado
                  const isPaidOrApproved = item.isPaidAgency || item.isPaidProvider || item.isPendigApprovePay;

                  if (isPaidOrApproved) {
                      // 4. Obtener valor histórico (ya convertido)
                      const historicValue = tax?.converted_amount || tax.amount || 0;
                      totalFixed += parseFloat(Number(historicValue).toFixed(2));
                  } else {
                      // 5. Procesar taxes no pagados (necesitan conversión)
                      if (!tax.amount || !tax.currency) return;

                      const taxCurrency = this.currencies.find(c => c.code === tax.currency);
                      if (!taxCurrency?.rate) return;

                      const taxRate = parseFloat(taxCurrency.rate);
                      const taxAmount = parseFloat(tax.amount);

                      if (!isNaN(taxRate) && !isNaN(taxAmount) && taxRate > 0) {
                          // Convertir a USD primero
                          const amountInUSD = taxAmount / taxRate;
                          totalConverted += amountInUSD;
                      }
                  }
              });
            }
        });

        // 6. Convertir solo la parte no pagada a la moneda de la agencia
        const convertedAmount = totalConverted * parseFloat(agencyRate);

        // 7. Sumar ambos totales (valores históricos + valores convertidos)
        const finalAmount = totalFixed + parseFloat(convertedAmount.toFixed(2));
        return parseFloat(finalAmount.toFixed(2));

    } catch (error) {
        console.error('Error en getTotalTaxesForStatus2:', error);
        return 0;
    }

}

  /**
   *
   * @returns Devuelve true o false en el caso que encuentre entre los items un producto que sea de hotel.
   */
  validateHotel():boolean{
    if(this.userService.itineraryActive.length > 0){
      if(this.userService.itineraryActive[0].items.length > 0){
        let validateHotel = this.userService.itineraryActive[0].items.find((hotel:any) => hotel.categoryName === 'HOTELS');
        if(validateHotel){
          return true;
        }else{
          return false;
        }
      }
    }

    return
  }


  /**
   * Obtiene la cantidad de los paxes en base a su type
   * @param data // Se le pasa el itinerario de la linea 266
   */
  validateQtyChildsAndAdults(data:any){



    if(data && Array.isArray(data) && data.length > 0 && data[0].paxList && Array.isArray(data[0].paxList)) {
      this.qtyAdults = data[0].paxList.filter((pax:any) => pax.type === 'adult').length || 0;
      this.qtyChilds = data[0].paxList.filter((pax:any) => pax.type === 'children').length || 0;
    } else {
      this.qtyAdults = 0;
      this.qtyChilds = 0;
    }


  }

  getAgesInItem(item: any): string {
  const expectedAges = this.getItemExpectedAges(item);

  if (!expectedAges || expectedAges.length === 0) {
    return '';
  }



  // Contar frecuencias de cada edad
  const ageCount: { [key: number]: number } = {};
  expectedAges.forEach(age => {
    ageCount[age] = (ageCount[age] || 0) + 1;
  });

  // Formatear el string
  const ageStrings: string[] = [];

  for (const [ageStr, count] of Object.entries(ageCount)) {
    const age = Number(ageStr); // ✅ Convertir a número

    if (count === 1) {
      ageStrings.push(`${age} año${age !== 1 ? 's' : ''}`);
    } else {
      ageStrings.push(`${count} de ${age} años`);
    }
  }

  // Unir con comas y "y"
  let result = '';
  if (ageStrings.length === 1) {
    result = ` (${ageStrings[0]})`;
  } else if (ageStrings.length === 2) {
    result = ` (${ageStrings[0]} y ${ageStrings[1]})`;
  } else {
    const last = ageStrings.pop();
    result = ` (${ageStrings.join(', ')} y ${last})`;
  }

  return result;
}

/**
 * Obtiene las edades esperadas para un item específico según su categoría
 */
getItemExpectedAges(item: any): number[] {
  const categoryId = item.category_id;
  let payloadUpdate;

  if (categoryId === 8) {
    payloadUpdate = item.payloadSync;
  } else {
    payloadUpdate = item.payloadUpdate;
  }

  if (!payloadUpdate) {
    return [];
  }

  let ages: number[] = [];

  switch (categoryId) {
    case 1: // HOTELES
      const roomConfigurations = payloadUpdate.products?.[0]?.others?.hotels?.roomConfiguration;
      if (roomConfigurations && Array.isArray(roomConfigurations)) {
        for (const room of roomConfigurations) {
          if (room.children && Array.isArray(room.children)) {
            ages.push(...room.children.map((age: any) => Number(age)));
          }
        }
      }
      break;

    case 2: // RENT A CAR
      const rentAcarChildren = payloadUpdate.childAge;
      if (rentAcarChildren && Array.isArray(rentAcarChildren)) {
        ages = rentAcarChildren.map((age: any) => Number(age));
      }
      break;

    case 6: // TOURS / EXPERIENCIAS
      const tourChildren = payloadUpdate.products?.[0]?.others?.tours?.children;
      if (tourChildren && Array.isArray(tourChildren)) {
        ages = tourChildren.map((age: any) => Number(age));
      }
      break;

    case 8: // TRANSPORTS / TRASLADOS
      const transferChildren = payloadUpdate.transfers.paxList.children;
      if (transferChildren && Array.isArray(transferChildren)) {
        ages = transferChildren.map((age: any) => Number(age));
      }
      break;

    case 9: // TICKETS
      const ticketChildren = payloadUpdate.products?.[0]?.others?.tours?.children;
      if (ticketChildren && Array.isArray(ticketChildren)) {
        ages = ticketChildren.map((age: any) => Number(age));
      }
      break;

    case 10: // ASISTENCIA / PAQUETES
      const assistanceChildren = payloadUpdate.products?.[0]?.insurances?.paxList?.paxAges?.filter((c: any) => c < 18) || [];
      if (assistanceChildren && Array.isArray(assistanceChildren)) {
        ages = assistanceChildren.map((age: any) => Number(age));
      }
      break;
  }

  return ages;
}


  getDurationTour(item): string {

  if(item.scheduling && Array.isArray(item.scheduling) && item.scheduling.length > 0) {
    return `${item.scheduling[0]?.duration?.value} ${item.scheduling[0]?.duration?.metric === 'HOURS' ? 'hs.' : 'min.'}`;
  }

  return '';
}

  getIconCategory(categoryName: string, item: any): string {
    switch (categoryName) {
      case 'TOURS':
        if(item.subCategoryId === 6) {
          return '/assets/img/app/categories-search-box/road-map.svg';
        }
        if(item.subCategoryId === 9) {
          return '/assets/img/app/categories-search-box/combi-ticket.svg';
        }
      case 'HOTELS':
        return '/assets/icons/itinerary/bed-svgrepo-com.svg';
      case 'PTHEMES':
        return '/assets/img/app/icon-pthemes-green.svg';
      case 'TRANSPORTS':
        return '/assets/icons/itinerary/school_15476203.svg';
      case 'DISNEY':
        return '/assets/img/app/disney-green.svg';
      case 'RENT-A-CAR':
        return '/assets/img/app/categories-search-box/car-compact.svg';
      case 'INSURANCE':
        return '/assets/img/app/categories-search-box/icon-seguro.svg';
      case 'CRUISES':
        return '/assets/img/app/icon-crucero-green.svg';
      default:
        return '/assets/img/app/icon-maletas-green.svg';
    }
  }


bedImage = 'data:image/png;base64,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';
tourImage = 'data:image/png;base64,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';
rentCarImage = ' data:image/png;base64,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';
locationImage = 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAARCAYAAADpPU2iAAAAAXNSR0IArs4c6QAAAARnQU1BAACxjwv8YQUAAAAJcEhZcwAADsMAAA7DAcdvqGQAAAGwSURBVDhPfVK7SgNBFF0/QVvzBUIys5sgCNGd2U0ifoRiJZYKImJjI5jdvCNqY62VVlpo5Rf4KgXJBygWRiw0u+M9s2M0Kh4Y7t57zn3M3bF+wq7LWafhX9tN/xWW1/w5Qw2CbXqjTt0/suveC6/IiId0yMK36/5xesNNGallpctuyq55ndzetCKR4oGMKSGx5CMOHjqdQOQJgqwsYiJUdruonGZBW/iIaz4UpxYL3XkeiF7S3ld21XtigVxmgSdZ6C3BRxw8C+U7JYg73R4JDf8NQt3WgFVcgTh46CyG6jSr0ypE9H1rdAOgkW7AQ0cd5AUyqQoqdIxmADwU94ZXlh1OTVBml2aNs62C4lWxbnQavCrXqDruhs096yB1aeV2S4oCMbZDo51TkRot4ww+4poPRFsnpLfyw7ziPdA29P6z7aLK7ZS0ha/jFfk4ViuN6ASAVrkAEc2b/OX+ERGqZwJ30Ui/QC0vk6qfSSLSfiCviB5KVN+QKbt5XNDsXL8l+E7gTRrJb9DODzAaXTwy9tBQfwOvllbYpcp4V93+g/sPvOyujO/P9KjbqgkZWNYH9sr6Grx5vEsAAAAASUVORK5CYII=';
}
